module.exports = __webpack_public_path__ + "img/pt.c3213f06.png";